import { LARGE, MEDIUM } from "../../../../../constants/breakpoints/breakpoints.js";
import "@mui/material/styles";
import "../../../../../themes/shadows/shadows.js";
import { typography } from "../../../../../themes/typography/typography.js";
import "react/jsx-runtime";
import "color-alpha";
import "@mui/material";
import { ExternalTheme } from "../../../../../themes/external-theme/external-theme.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
const wrapperStyles = {
  backgroundColor: "primary.10",
  pt: 12,
  pb: 12,
  [ExternalTheme.breakpoints.down(LARGE)]: {
    pb: 10
  },
  [ExternalTheme.breakpoints.down(MEDIUM)]: {
    pb: 6
  }
};
const titleStyles = {
  ...typography["Lato H5 Bold"],
  color: ExternalTheme.palette.primary.main,
  textTransform: "uppercase",
  mb: 2
};
const contentStyles = {
  ...typography["Lato Body 1"],
  color: "grey.800",
  marginBottom: "48px",
  ":last-child": {
    marginBottom: "32px"
  },
  [ExternalTheme.breakpoints.down(LARGE)]: {
    marginBottom: "40px"
  },
  [ExternalTheme.breakpoints.down(MEDIUM)]: {
    marginBottom: "32px"
  },
  strong: {
    fontWeight: 400
  },
  li: {
    listStyle: "initial",
    listStylePosition: "inside",
    "> p": {
      display: "inline"
    }
  }
};
const buttonStyles = {
  alignSelf: "center"
};
export {
  buttonStyles,
  contentStyles,
  titleStyles,
  wrapperStyles
};
